module.exports = __webpack_public_path__ + "img/IMG_8952.b57059e6.jpg";